import React from "react";

// Utility function to format date separators
const formatDateSeparator = (timestamp) => {
    const date = new Date(timestamp);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    const messageDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate()
    );
    const todayDate = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
    );
    const yesterdayDate = new Date(
        yesterday.getFullYear(),
        yesterday.getMonth(),
        yesterday.getDate()
    );

    if (messageDate.getTime() === todayDate.getTime()) {
        return "Today";
    } else if (messageDate.getTime() === yesterdayDate.getTime()) {
        return "Yesterday";
    } else {
        return date.toLocaleDateString("en-US", {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
        });
    }
};

const DateSeparator = ({ date }) => (
    <div className="flex items-center justify-center my-4">
        <div className="flex-grow border-t border-gray-300"></div>
        <span className="px-4 py-1 bg-gray-100 text-gray-600 text-xs font-medium rounded-full">
            {formatDateSeparator(date)}
        </span>
        <div className="flex-grow border-t border-gray-300"></div>
    </div>
);

export default DateSeparator;
